import React from 'react';

import marketingCampaigns from 'assets/images/Campaigns.svg';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';

const CampaignsHeader = (props) => {
  const { revenueGenerated, bookingsRecieved, clientsMessaged, campaignsSent } = props;

  const { t } = useTranslation();

  return (
    <>
      <div className="campaigns-header">
        <img className="img_position" src={marketingCampaigns} alt="" />
        <div className="campaigns-items">
          <div className="c-item">
            <span className="c-number">{campaignsSent}</span>
            <div className="c-name">{t('campaigns.campaignsSentIndicator')}</div>
          </div>
          <div className="c-item">
            <span className="c-number">{clientsMessaged}</span>
            <div className="c-name">{t('campaigns.messagedClientsIndicator')}</div>
          </div>
          <div className="c-item">
            <span className="c-number">{bookingsRecieved}</span>
            <div className="c-name">{t('campaigns.receivedBookingsIndicator')}</div>
          </div>
          <div className="c-item">
            <span className="c-number">
              <CurrencySign />
              {revenueGenerated}
            </span>
            <div className="c-name">{t('campaigns.generatedRevenueIndicator')}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CampaignsHeader;
